export const ProductType = {
  ADMISSION_ITEM: 'AdmissionItem',
  SESSION: 'Session',
  HOTEL_ITEM: 'HotelItem',
  QUANTITY_ITEM: 'QuantityItem',
  OPTIONAL_ITEM: 'OptionalItem',
  DONATION_ITEM: 'DonationItem'
};
